import React from 'react'

function OurJourney() {
  return (
    <section id="journey">
    <div className="container-fluid padding mt-5">
      <div className="row welcome text-center">
        <div className="col-12 mb-4">
          <h1 className="display-4">Our Journey</h1>
        </div>
        <hr />
        <div className="col-12">
          <p className="lead mt-5">
            Aryavart Expo Staffing Solutions is located in Srikakulam, India, offering fully fledged services for software development and engineering empowering effective near-shore management to its clients. Recognized both on local and regional markets since many years.
          </p>
        </div>
        <div className="col-12">
          <p className="lead ">
            Aryavart continues to operate with higher client expectancy and flexible solution offers. Aryavart Expo staffing solutions  is a pioneer in Interactive Vir- tual Teams (IVT) which enables the client and the service provider to  establish instant and successful communication channels and supports off-shoring and near-shoring business models, thus keeping the deadlines on time and on track. </p>
        </div>
        <div className="col-12">
          <p className="lead ">
            Aryavart's differentiation point comes with three simple principles:
            <ul type="none">
              <li className="mt-1">True collaboration with customers and partners.</li>
               <li className="mt-1">Complete understanding of customers business.</li>
               <li  className="mt-1"> Persistence in finishing the job whatever it takes.</li>
            </ul> </p>
        </div>
        <div className="col-12">
          <p className="lead ">
            Aryavart started its journey with an ambition to build a software team which will provide software services using cutting edge technologies ensuring quality and reliability. We had already worked to define our standards and be proficient in the industry best practices. The plan was to do some thing so that we can overcome the challenges we experienced in the previous companies we served. </p>
        </div>
      </div>
    </div>
  </section>
  )
}

export default OurJourney
